import { useEffect } from "react";
import useVh from "./useVh";

function useFallcackCalc(element, varName, vh, option) {
  const { when = true, ...restOption } = option ?? {};
  const adjust = useVh(vh, restOption);

  useEffect(() => {
    if (!when) return undefined;

    let cancelled = false;
    let retryCount = 0;

    const apply = () => {
      if (cancelled) return undefined;

      let $element = element;
      if ($element && typeof $element === "object" && "current" in $element) {
        $element = $element.current;
      } else if (typeof $element === "string") {
        $element = document.querySelector($element);
      }

      if ($element && varName) {
        $element.style.setProperty(varName, `${adjust}px`);
        return undefined;
      }

      if (retryCount < 12) {
        retryCount += 1;
        requestAnimationFrame(apply);
        return undefined;
      }

      return undefined;
    };

    const timer = setTimeout(apply, 0);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [when, adjust, element, varName]);
}

export default useFallcackCalc;

export const root = document.documentElement;
